import React, { ReactNode } from 'react';
import { Modal, ModalProps } from 'antd';
import './CustomModal.scss';
import { useAppDispatch } from '@/store/hooks/useAppDispatch';
import { closeModal } from '@/store/modal/slice';
import { getModaOpenModalId } from '@/store/modal/selector';
import { useAppSelector } from '@/store/hooks/useAppSelector';
import { MODAL_IDS } from 'src/enums/EModal';

export const CustomModal: React.FC<
	{
		title: ReactNode;
		description?: ReactNode;
		children: ReactNode;
		isModalOpen?: boolean;
		confirmAction?: () => void;
		cancelAction?: () => void;
		modalId?: MODAL_IDS | null;
		icon?: ReactNode;
	} & Omit<ModalProps, 'title' | 'open' | 'onOk' | 'onCancel'>
> = ({
	title,
	description,
	children,
	isModalOpen,
	modalId,
	confirmAction,
	cancelAction,
	icon,
	...rest
}) => {
	const dispatch = useAppDispatch();
	const openModalId = useAppSelector(getModaOpenModalId);

	return (
		<Modal
			className="custom-modal"
			title={
				<div className="modal-header-container">
					<div className="flex items-center">
						{icon && <div className="text-blue-600 mr-2">{icon}</div>}
						<h1 className="text-xl font-semibold text-gray-800">{title}</h1>
					</div>
					{description && (
						<div className="modal-description">
							<span>{description}</span>
						</div>
					)}
				</div>
			}
			open={modalId ? !!(openModalId && openModalId === modalId) : isModalOpen}
			onCancel={() => (cancelAction ? cancelAction() : dispatch(closeModal()))}
			onOk={confirmAction}
			{...rest}
		>
			{children}
		</Modal>
	);
};
